/**
 * @generated SignedSource<<f4bb97e7caaf8c704eb88d29056fde27>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContinueYourProductCardFragment$data = {
  readonly curriculum: {
    readonly id: string;
  } | null;
  readonly todos: number;
  readonly viewerMembership: {
    readonly " $fragmentSpreads": FragmentRefs<"MemberCurriculumProgressBarFragment">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProductCardFragment">;
  readonly " $fragmentType": "ContinueYourProductCardFragment";
};
export type ContinueYourProductCardFragment$key = {
  readonly " $data"?: ContinueYourProductCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContinueYourProductCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContinueYourProductCardFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductCardFragment"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "todos",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Curriculum",
      "kind": "LinkedField",
      "name": "curriculum",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductMembership",
      "kind": "LinkedField",
      "name": "viewerMembership",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MemberCurriculumProgressBarFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "8a1c73fe19a5fe544ec9be83ed816258";

export default node;
